import { render, staticRenderFns } from "./LhcVyber.vue?vue&type=template&id=6f2d74e5&"
import script from "./LhcVyber.vue?vue&type=script&lang=js&"
export * from "./LhcVyber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports